export const searchBarPlaceholders = {
  name_or_mrn_or_code: "Search by Patient Name or MRN",
  patient_name_or_mrn_or_code: "Search by Patient Name or MRN",
  name: "Search by User Name"
};
